import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box, Button, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";
import {areasData} from "../../data/areasData";
import AreaDetailsModal from "./AreaDetailsModal";

const ITEMS_PER_LOAD = 8;

export default function OurWorkingAreas() {
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_LOAD);
  const [selectedArea, setSelectedArea] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const visibleAreas = areasData.slice(0, visibleCount);
  const hasMore = visibleCount < areasData.length;

  return (
    // <Box
    //   sx={{
    //     backgroundColor: "#212121",
    //     py: { xs: 10, md: 16 },
    //     overflow: "hidden",
    //   }}
    // >
    <Box
      sx={{
        backgroundColor: "var(--color-bg)",
        py: { xs: 4, md: 4 },
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADER */}
        <Box textAlign="center" mb={{ xs: 2, md: 2 }}>
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.35em",
              fontSize: 11,
              mb: 1,
            }}
          >
            OUR PRESENCE
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 500,
              // mb: 1,
            }}
          >
            <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
              Our Working{" "}
            </Box>

            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Areas
            </Box>
          </Typography>

          <Typography
            sx={{
              // color: "rgba(255,255,255,0.65)",
              color: "var(--color-text-muted)",

              maxWidth: 720,
              mx: "auto",
              fontSize: 15,
              lineHeight: 2,
            }}
          >
            We operate across Sharjah, Dubai, and Ajman — delivering refined
            real estate services in high-growth locations.
          </Typography>
        </Box>

        {/* GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: { xs: 3, md: 4 },
          }}
        >
          {visibleAreas.map((area, i) => (
            <motion.div
              key={area.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              viewport={{ once: true }}
            >
              {/* <Box
                sx={{
                  position: "relative",
                  height: 300,
                  borderRadius: "26px",
                  overflow: "hidden",
                  backgroundColor: "#000",
                  cursor: "pointer",
                  boxShadow:
                    "0 30px 70px rgba(0,0,0,0.85), inset 0 0 0 1px rgba(255,255,255,0.04)",
                  transition: "all 0.5s ease",

                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow:
                      "0 55px 120px rgba(0,0,0,0.95), 0 0 0 1px rgba(201,162,77,0.45)",
                  },

                  "&:hover img": {
                    transform: "scale(1.12)",
                  },
                }}
              > */}

              <Box
                onClick={() => {
                  setSelectedArea(area);
                  setOpenModal(true);
                }}
                sx={{
                  position: "relative",
                  height: 300,
                  borderRadius: "26px",
                  overflow: "hidden",
                  backgroundColor: "var(--color-white)",
                  cursor: "pointer",
                  boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
                  transition: "all 0.45s ease",

                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 35px 80px rgba(0,0,0,0.25)",
                  },

                  "&:hover img": {
                    transform: "scale(1.08)",
                  },
                }}
              >
                {/* IMAGE (LAZY LOAD) */}
                <Box
                  component="img"
                  src={area.image}
                  alt={area.title}
                  loading="lazy"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 1.1s ease",
                    filter: "saturate(1.05) contrast(1.05)",
                  }}
                />

                <Box
                  className="area-actions"
                  sx={{
                    position: "absolute",
                    top: 14,
                    right: 14,
                    display: "flex",
                    gap: 1,
                    zIndex: 6,
                  }}
                >
                  {/* VIEW BUTTON */}
                  <Button
                    href={area.viewLink}
                    target="_blank"
                    startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: "auto",
                      px: 1.6,
                      py: 0.45,
                      height: 28,
                      borderRadius: "999px",
                      fontSize: 11,
                      fontWeight: 500,
                      textTransform: "none",
                      color: "#111",
                      background: "rgba(201,162,77,0.9)",
                      backdropFilter: "blur(6px)",
                      boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
                      transition: "all 0.25s ease",

                      "& .MuiButton-startIcon": {
                        marginRight: 0.5,
                      },

                      "&:hover": {
                        background: "rgba(201,162,77,1)",
                        transform: "translateY(-1px)",
                        boxShadow: "0 10px 28px rgba(0,0,0,0.45)",
                      },
                    }}
                  >
                    View
                  </Button>

                  {/* MAP BUTTON */}
                  <Button
                    href={area.mapLink}
                    target="_blank"
                    startIcon={<LocationOnOutlinedIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      minWidth: "auto",
                      px: 1.6,
                      py: 0.45,
                      height: 28,
                      borderRadius: "999px",
                      fontSize: 11,
                      fontWeight: 500,
                      textTransform: "none",
                      color: "#fff",
                      background: "rgba(0,0,0,0.6)",
                      backdropFilter: "blur(6px)",
                      border: "1px solid rgba(255,255,255,0.25)",
                      transition: "all 0.25s ease",

                      "& .MuiButton-startIcon": {
                        marginRight: 0.5,
                      },

                      "&:hover": {
                        background: "rgba(0,0,0,0.85)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Get Directions
                  </Button>
                </Box>

                {/* <Box
                  sx={{
                    position: "absolute",
                    top: 14,
                    right: 14,
                    display: "flex",
                    gap: 1,
                    zIndex: 5, // ✅ Above overlay
                  }}
                  onMouseEnter={(e) => e.stopPropagation()}
                  onMouseLeave={(e) => e.stopPropagation()}
                >
                  <IconButton
                    href={area.viewLink}
                    sx={{
                      backgroundColor: "rgba(0,0,0,0.65)",
                      color: "var(--color-gold)",
                      backdropFilter: "blur(8px)",
                      border: "1px solid rgba(201,162,77,0.35)",
                      transition: "all 0.3s ease",

                      "&:hover": {
                        backgroundColor: "rgba(201,162,77,0.85)",
                        color: "#111",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <VisibilityOutlinedIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    href={area.mapLink}
                    target="_blank"
                    sx={{
                      backgroundColor: "rgba(0,0,0,0.65)",
                      color: "var(--color-gold)",
                      backdropFilter: "blur(8px)",
                      border: "1px solid rgba(201,162,77,0.35)",
                      transition: "all 0.3s ease",

                      "&:hover": {
                        backgroundColor: "rgba(201,162,77,0.85)",
                        color: "#111",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <LocationOnOutlinedIcon fontSize="small" />
                  </IconButton>
                </Box> */}

                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0.88))",
                    pointerEvents: "none",
                  }}
                />

                {/* TITLE */}
                <Box
                  sx={{ position: "absolute", bottom: 22, left: 22, right: 22 }}
                >
                  <Typography
                    sx={{ color: "#fff", fontSize: 16, fontWeight: 500 }}
                  >
                    {area.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.7)",
                      fontSize: 13,
                      mt: 0.6,
                      lineHeight: 1.6,
                    }}
                  >
                    {area.description}
                  </Typography>

                  <Box
                    sx={{
                      width: 36,
                      height: 2,
                      background:
                        "linear-gradient(90deg, var(--color-gold), transparent)",
                      mt: 1.4,
                    }}
                  />
                </Box>
              </Box>
            </motion.div>
          ))}
        </Box>

        {/* LOAD MORE */}
        {hasMore && (
          <Box textAlign="center" mt={10}>
            <Button
              onClick={() => setVisibleCount((prev) => prev + ITEMS_PER_LOAD)}
              sx={{
                px: 5,
                py: 1.6,
                borderRadius: "40px",
                color: "var(--color-gold)",
                border: "1px solid rgba(201,162,77,0.6)",
                background: "rgba(255,255,255,0.04)",
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                fontSize: 12,
                "&:hover": {
                  background: "rgba(201,162,77,0.12)",
                },
              }}
            >
              Load More Areas
            </Button>
          </Box>
        )}
      </Container>

      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />

      <AreaDetailsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        area={selectedArea}
      />
    </Box>
  );
}
